import { GetCsvFileAdminGrop } from "../../faetures/fetch";


export default function TableProjectAdmin ({names}) {
    console.log(names)
    const head = ["מס'", "שם", "הורדה טיסות", " עדכון טיסות"];

    return(<>
    { names ? 
        <div className="scrool">
            <table>
                <thead>
                    <tr> {head.map((value, key) => <td key={key}> {value} </td>)} </tr>
                </thead>

                <tbody>
                {names && names.map((value, key) =>
                    <tr key={key}>
                        <td> {key + 1} </td>
                        <td> {value} </td>
                        <td onClick={() => GetCsvFileAdminGrop(value + '.csv')}> {`הורדת קובץ ${value}`} </td>
                        <td onClick={() => GetCsvFileAdminGrop(`נסיעות פנים ${value}.csv`)}> {` הורדה קובץ נ"פ ${value}`} </td>
                    </tr>
                )}
                </tbody>
            </table>
        </div> :
        <p> אין טיסות </p>
    }
    </>)
}